/** Сравнение без регистра и разницы «ё/е». */
export const normalizeSearch = (text: string) => text.toLowerCase().replace(/ё/g, "е")

/** Фильтр cmdk по подстроке: нечёткий скоринг cmdk на «оплата» находит «Пользователей». */
export function filterBySubstring(value: string, search: string, keywords: string[] = []) {
  return normalizeSearch([value, ...keywords].join(" ")).includes(normalizeSearch(search.trim())) ? 1 : 0
}
